import React, { Component } from 'react'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import { Link } from 'react-router-dom'
import Grafica from "../../charts/Grafica"
import Chart from "../../charts/Chart"
import AuthenticationService from '../general/AuthenticationService.js'

const T = {
    bg: '#f1f5f9', card: '#ffffff', border: '#e8edf5',
    blue: '#3b82f6', blueD: '#2563eb', navy: '#0f172a',
    txt: '#1e293b', txt2: '#64748b', muted: '#94a3b8',
    green: '#16a34a', greenBg: '#f0fdf4', greenBdr: '#bbf7d0',
    red: '#dc2626', redBg: '#fef2f2', redBdr: '#fecaca',
    r: 16, rsm: 10, shadow: '0 1px 3px rgba(15,23,42,.06)',
    font: "'Inter',-apple-system,BlinkMacSystemFont,sans-serif"
}

const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
                'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']

function formatMoney(amount, decimalCount = 2, decimal = '.', thousands = ',') {
    if (isNaN(amount)) return '—'
    try {
        decimalCount = Math.abs(isNaN(decimalCount) ? 2 : decimalCount)
        const negativeSign = amount < 0 ? '-' : ''
        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
        let j = i.length > 3 ? i.length % 3 : 0
        return negativeSign + (j ? i.substr(0, j) + thousands : '') +
            i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
            (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
    } catch (e) { return '—' }
}

function getStatusType(s) {
    if (!s) return 'default'
    const u = s.toUpperCase()
    if (u.includes('ACTIV')) return 'green'
    if (u.includes('SUSPEND') || u.includes('LIQUID') || u.includes('VEND')) return 'red'
    return 'default'
}

function Badge({ text, type = 'default' }) {
    const colors = {
        default: { bg: '#f1f5f9', color: T.txt2, border: T.border },
        green:   { bg: T.greenBg, color: T.green, border: T.greenBdr },
        red:     { bg: T.redBg,   color: T.red,   border: T.redBdr },
        blue:    { bg: '#eff6ff', color: T.blue,  border: '#bfdbfe' },
    }
    const c = colors[type] || colors.default
    if (!text) return <span style={{ color: T.muted }}>—</span>
    return (
        <span style={{ fontSize: '0.75rem', fontWeight: 700, background: c.bg, color: c.color, border: `1px solid ${c.border}`, borderRadius: 20, padding: '3px 10px', display: 'inline-block' }}>
            {text}
        </span>
    )
}

function InfoRow({ label, children }) {
    return (
        <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', gap: 12, padding: '10px 0', borderBottom: `1px solid ${T.border}`, alignItems: 'start' }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 600, color: T.txt2 }}>{label}</span>
            <span style={{ fontSize: '0.85rem', color: T.txt }}>{children || <span style={{ color: T.muted }}>—</span>}</span>
        </div>
    )
}

function StatCard({ label, value, icon }) {
    return (
        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: T.r, padding: '20px 24px', boxShadow: T.shadow, flex: 1, minWidth: 200 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <span style={{ fontSize: '1.2rem' }}>{icon}</span>
                <span style={{ fontSize: '0.72rem', fontWeight: 700, color: T.muted, letterSpacing: '1px', textTransform: 'uppercase' }}>{label}</span>
            </div>
            <div style={{ fontSize: '1.4rem', fontWeight: 800, color: T.navy, fontVariantNumeric: 'tabular-nums' }}>
                ${formatMoney(value)}
            </div>
        </div>
    )
}

class SociedadReporteContableComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: '', correo: '', password: '', generacion: '',
            domicilios: [], opinionCumplimiento: '', pendientes: '',
            razonSocial: '', revisionFiscal: '', status: '',
            statusContabilidad: '', situacion: '', tipo: '',
            rfc: this.props.match.params.rfc,
            clientes: [],
            primerAño: 0, ultimoAño: 0,
            totalIngresosFacturados: 0, totalNominaTimbrada: 0,
            ingresosPerYear: [], ingresosPerYearMonth: [],
            nominaPerYear: [], nominaPerYearMonth: [],
            yerMonthGraph: [], yearMonthNominaGraph: [],
            historialSociedadDomicilios: [],
            loading: true,
            error: null,
        }
        this.print = this.print.bind(this)
    }

    print() { window.print() }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("READ_CONTABILIDAD")) {
            alert("Usuario no autorizado")
            this.props.history.push('/login')
            return
        }

        const { match: { params } } = this.props
        if (Number(params.id) === -1) { this.setState({ loading: false }); return }

        // Load contabilidad data
        ElementsDataService.retrieveElement("contabilidad", this.state.rfc)
            .then(response => {
                const d = response.data

                if (d.primerAño == 0 || d.totalIngresosFacturados == null) {
                    alert("No hay CFDIs registrados para este RFC")
                    this.props.history.push("/Sociedades")
                    return
                }

                this.setState({
                    primerAño: d.primerAño,
                    ultimoAño: d.ultimoAño,
                    totalIngresosFacturados: d.totalIngresosFacturados,
                    totalNominaTimbrada: d.totalNominaTimbrada,
                    ingresosPerYear: d.ingresosPerYear,
                    ingresosPerYearMonth: d.ingresosPerYearMonth,
                    nominaPerYear: d.nominaPerYear,
                    nominaPerYearMonth: d.nominaPerYearMonth,
                }, () => {
                    // Build chart data after state is set
                    const { primerAño, ultimoAño, ingresosPerYearMonth, nominaPerYearMonth } = this.state
                    let yerMonthGraphData = []
                    let yearMonthNominaGraphData = []

                    for (let año = primerAño; año <= ultimoAño; año++) {
                        for (let mes = 1; mes <= 12; mes++) {
                            const añoMes = año.toString() + mes.toString()
                            yerMonthGraphData.push({ mes: meses[mes - 1], year: año, ingresos: ingresosPerYearMonth[añoMes] })
                            yearMonthNominaGraphData.push({ mes: meses[mes - 1], year: año, ingresos: nominaPerYearMonth[añoMes] })
                        }
                    }

                    const yerMonthGraph = [<Chart key="ing" ingresosPerMonthYear={yerMonthGraphData} divId="#ingresosChart" />]
                    const yearMonthNominaGraph = [<Chart key="nom" ingresosPerMonthYear={yearMonthNominaGraphData} divId="#nominasChart" />]
                    this.setState({ yerMonthGraph, yearMonthNominaGraph, loading: false })
                })
            })
            .catch(() => this.setState({ loading: false, error: 'Error al cargar datos contables' }))

        // Load sociedad info
        ElementsDataService.retrieveElement("sociedades/rfc", this.state.rfc)
            .then(response => {
                const d = response.data
                this.setState({
                    id: d.id, correo: d.correo, password: d.password,
                    generacion: d.generacion, domicilios: d.domicilios || [],
                    opinionCumplimiento: d.opinionCumplimiento, pendientes: d.pendientes,
                    razonSocial: d.razonSocial, revisionFiscal: d.revisionFiscal,
                    status: d.status, statusContabilidad: d.statusContabilidad,
                    situacion: d.situacion, tipo: d.tipo,
                    rfc: d.rfc, clientes: d.clientes || [],
                })
                return ElementsDataService.retrieveElement("sociedades", d.id)
            })
            .then(response => {
                this.setState({ historialSociedadDomicilios: response.data.historialSociedadDomicilios || [] })
            })
            .catch(() => {})
    }

    render() {
        const {
            id, razonSocial, rfc, tipo, status, statusContabilidad, clientes,
            domicilios, historialSociedadDomicilios,
            primerAño, ultimoAño,
            totalIngresosFacturados, totalNominaTimbrada,
            ingresosPerYear, ingresosPerYearMonth,
            nominaPerYear, nominaPerYearMonth,
            yerMonthGraph, yearMonthNominaGraph,
            loading, error,
        } = this.state

        // Sort domicilios
        const domOrdenados = [...(domicilios || [])].sort((a, b) => {
            let fa = 0, fb = 0
            historialSociedadDomicilios.filter(h => h.domicilioId == a.id).forEach(h => { const p = Date.parse(h.fechaInicio); if (!isNaN(p)) fa = p })
            historialSociedadDomicilios.filter(h => h.domicilioId == b.id).forEach(h => { const p = Date.parse(h.fechaInicio); if (!isNaN(p)) fb = p })
            return fb - fa
        })
        const ultimoDomicilio = domOrdenados[0] || null

        // Year header + rows
        const años = []
        for (let a = primerAño; a <= ultimoAño; a++) años.push(a)

        // Monthly tables per year
        const tablaYearMonth = (year) => {
            const firstHalf  = [1,2,3,4,5,6]
            const secondHalf = [7,8,9,10,11,12]

            const row = (mesesList, map) => mesesList.map(mes => {
                const key = year.toString() + mes.toString()
                return <td key={mes} style={styles.tdMoney}>{formatMoney(map[key])}</td>
            })

            return (
                <div key={year} style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: '0.78rem', fontWeight: 700, color: T.muted, letterSpacing: '1px', textTransform: 'uppercase', marginBottom: 8, padding: '0 4px' }}>
                        Ejercicio {year}
                    </div>
                    <div style={{ overflowX: 'auto' }}>
                        <table style={styles.table}>
                            <thead>
                                <tr style={styles.thead}>
                                    <th style={styles.th}>Concepto</th>
                                    {firstHalf.map(m => <th key={m} style={styles.thRight}>{meses[m-1]}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={styles.tr}><td style={styles.td}>Ingresos Facturados</td>{row(firstHalf, ingresosPerYearMonth)}</tr>
                                <tr style={styles.tr}><td style={styles.td}>Nómina Timbrada</td>{row(firstHalf, nominaPerYearMonth)}</tr>
                            </tbody>
                            <thead>
                                <tr style={styles.thead}>
                                    <th style={styles.th}>Concepto</th>
                                    {secondHalf.map(m => <th key={m} style={styles.thRight}>{meses[m-1]}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={styles.tr}><td style={styles.td}>Ingresos Facturados</td>{row(secondHalf, ingresosPerYearMonth)}</tr>
                                <tr style={styles.tr}><td style={styles.td}>Nómina Timbrada</td>{row(secondHalf, nominaPerYearMonth)}</tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )
        }

        if (loading) {
            return (
                <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: T.font }}>
                    <div style={{ textAlign: 'center' }}>
                        <div style={{ width: 40, height: 40, border: `3px solid ${T.border}`, borderTopColor: T.blue, borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
                        <p style={{ color: T.muted, margin: 0, fontSize: '0.9rem' }}>Cargando reporte contable...</p>
                        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                    </div>
                </div>
            )
        }

        if (error) {
            return (
                <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: T.font }}>
                    <div style={{ textAlign: 'center', color: T.red }}>
                        <div style={{ fontSize: '2rem', marginBottom: 12 }}>⚠️</div>
                        <p style={{ margin: 0 }}>{error}</p>
                    </div>
                </div>
            )
        }

        return (
            <div style={{ minHeight: '100vh', background: T.bg, fontFamily: T.font }}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
                    * { box-sizing: border-box; }
                    .rc-link { color: ${T.blue}; text-decoration: none; font-weight: 600; }
                    .rc-link:hover { text-decoration: underline; }
                    @media print {
                        .no-print { display: none !important; }
                        body { background: white !important; }
                    }
                `}</style>

                <div style={{ maxWidth: 1100, margin: '0 auto', padding: '28px 24px' }}>

                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
                        <div>
                            <button
                                className="no-print"
                                onClick={() => this.props.history.goBack()}
                                style={{ background: 'white', border: `1px solid ${T.border}`, borderRadius: T.rsm, padding: '8px 16px', cursor: 'pointer', fontSize: '0.82rem', color: T.txt2, fontFamily: T.font, marginBottom: 12 }}
                            >
                                ‹ Volver
                            </button>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                                <span style={{ fontSize: '0.7rem', fontWeight: 700, background: '#eff6ff', color: T.blue, border: '1px solid #bfdbfe', borderRadius: 20, padding: '3px 10px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                                    Reporte Contable
                                </span>
                                <Badge text={status} type={getStatusType(status)} />
                                <Badge text={statusContabilidad} type={getStatusType(statusContabilidad)} />
                            </div>
                            <h1 style={{ margin: '0 0 4px', fontSize: '1.5rem', fontWeight: 800, color: T.navy }}>{razonSocial || rfc}</h1>
                            <span style={{ fontFamily: 'monospace', fontSize: '0.95rem', color: T.txt2, fontWeight: 600 }}>{rfc}</span>
                        </div>
                        <button
                            className="no-print"
                            onClick={this.print}
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '10px 20px', background: T.navy, color: 'white', border: 'none', borderRadius: T.rsm, cursor: 'pointer', fontSize: '0.85rem', fontWeight: 600, fontFamily: T.font }}
                        >
                            🖨️ Imprimir
                        </button>
                    </div>

                    {/* Info card */}
                    <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: T.r, padding: '20px 24px', marginBottom: 20, boxShadow: T.shadow }}>
                        <h2 style={{ margin: '0 0 14px', fontSize: '0.72rem', fontWeight: 700, color: T.muted, letterSpacing: '1.5px', textTransform: 'uppercase' }}>Datos de la Sociedad</h2>
                        <InfoRow label="Razón Social">
                            {id ? <Link to={`/sociedades/reportes/${id}`} className="rc-link">{razonSocial}</Link> : razonSocial}
                        </InfoRow>
                        <InfoRow label="RFC"><span style={{ fontFamily: 'monospace' }}>{rfc}</span></InfoRow>
                        <InfoRow label="Tipo de Sociedad">{tipo}</InfoRow>
                        <InfoRow label="Estatus Legal"><Badge text={status} type={getStatusType(status)} /></InfoRow>
                        <InfoRow label="Estatus Contable"><Badge text={statusContabilidad} type={getStatusType(statusContabilidad)} /></InfoRow>
                        <InfoRow label="Proyectos">
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                                {clientes.length ? clientes.map(c => (
                                    <Link key={c.id} to={`/clientes/reportes/${c.id}`} style={{ fontSize: '0.8rem', background: '#eff6ff', color: T.blue, border: '1px solid #bfdbfe', borderRadius: 20, padding: '3px 12px', textDecoration: 'none', fontWeight: 600 }}>
                                        {c.nombreCliente}
                                    </Link>
                                )) : <span style={{ color: T.muted }}>—</span>}
                            </div>
                        </InfoRow>
                    </div>

                    {/* Último domicilio */}
                    {ultimoDomicilio && (
                        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: T.r, padding: '20px 24px', marginBottom: 20, boxShadow: T.shadow }}>
                            <h2 style={{ margin: '0 0 14px', fontSize: '0.72rem', fontWeight: 700, color: T.muted, letterSpacing: '1.5px', textTransform: 'uppercase' }}>Último Domicilio Registrado</h2>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 32px' }}>
                                <div>
                                    <InfoRow label="Calle">{ultimoDomicilio.calle}</InfoRow>
                                    <InfoRow label="Número Exterior">{ultimoDomicilio.numeroExt}</InfoRow>
                                    <InfoRow label="Número Interior">{ultimoDomicilio.numeroInterior}</InfoRow>
                                    <InfoRow label="Colonia">{ultimoDomicilio.colonia}</InfoRow>
                                </div>
                                <div>
                                    <InfoRow label="Código Postal">{ultimoDomicilio.cp}</InfoRow>
                                    <InfoRow label="Municipio">{ultimoDomicilio.municipio}</InfoRow>
                                    <InfoRow label="Estado">{ultimoDomicilio.estado}</InfoRow>
                                    <InfoRow label="Teléfono">{ultimoDomicilio.telefono}</InfoRow>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Resumen totales */}
                    <div style={{ display: 'flex', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
                        <StatCard label="Total Ingresos Facturados" value={totalIngresosFacturados} icon="📈" />
                        <StatCard label="Total Nómina Timbrada" value={totalNominaTimbrada} icon="👥" />
                    </div>

                    {/* Tabla resumen por año */}
                    {años.length > 0 && (
                        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: T.r, padding: '20px 24px', marginBottom: 20, boxShadow: T.shadow }}>
                            <h2 style={{ margin: '0 0 14px', fontSize: '0.72rem', fontWeight: 700, color: T.muted, letterSpacing: '1.5px', textTransform: 'uppercase' }}>Ejercicios Facturados</h2>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={styles.table}>
                                    <thead>
                                        <tr style={styles.thead}>
                                            <th style={styles.th}>Concepto</th>
                                            {años.map(a => <th key={a} style={styles.thRight}>{a}</th>)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={styles.tr}>
                                            <td style={styles.td}>Ingresos Facturados</td>
                                            {años.map(a => <td key={a} style={styles.tdMoney}>{formatMoney(ingresosPerYear[a])}</td>)}
                                        </tr>
                                        <tr style={styles.tr}>
                                            <td style={styles.td}>Nómina Timbrada</td>
                                            {años.map(a => <td key={a} style={styles.tdMoney}>{formatMoney(nominaPerYear[a])}</td>)}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* Tablas por año/mes */}
                    {años.length > 0 && (
                        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: T.r, padding: '20px 24px', marginBottom: 20, boxShadow: T.shadow }}>
                            <h2 style={{ margin: '0 0 16px', fontSize: '0.72rem', fontWeight: 700, color: T.muted, letterSpacing: '1.5px', textTransform: 'uppercase' }}>Desglose Mensual</h2>
                            {años.map(a => tablaYearMonth(a))}
                        </div>
                    )}

                    {/* Gráficas */}
                    {yerMonthGraph && yerMonthGraph.length > 0 && (
                        <div style={{ marginBottom: 20 }}>
                            <p style={{ margin: '0 0 10px 4px', fontSize: '0.72rem', fontWeight: 700, color: T.muted, letterSpacing: '1.5px', textTransform: 'uppercase' }}>Gráfica de Ingresos</p>
                            {yerMonthGraph}
                        </div>
                    )}

                    {yearMonthNominaGraph && yearMonthNominaGraph.length > 0 && (
                        <div style={{ marginBottom: 20 }}>
                            <p style={{ margin: '0 0 10px 4px', fontSize: '0.72rem', fontWeight: 700, color: T.muted, letterSpacing: '1.5px', textTransform: 'uppercase' }}>Gráfica de Nómina</p>
                            {yearMonthNominaGraph}
                        </div>
                    )}

                </div>
            </div>
        )
    }
}

const styles = {
    table: { width: '100%', borderCollapse: 'collapse', fontSize: '0.83rem' },
    thead: { background: '#f8fafc' },
    th: { padding: '10px 14px', textAlign: 'left', fontSize: '0.72rem', fontWeight: 700, color: T.txt2, letterSpacing: '0.5px', borderBottom: `1px solid ${T.border}`, whiteSpace: 'nowrap' },
    thRight: { padding: '10px 14px', textAlign: 'right', fontSize: '0.72rem', fontWeight: 700, color: T.txt2, letterSpacing: '0.5px', borderBottom: `1px solid ${T.border}`, whiteSpace: 'nowrap' },
    tr: { borderBottom: `1px solid ${T.border}` },
    td: { padding: '10px 14px', color: T.txt, fontSize: '0.83rem' },
    tdMoney: { padding: '10px 14px', color: T.txt, fontSize: '0.83rem', textAlign: 'right', fontVariantNumeric: 'tabular-nums', fontFamily: 'monospace' },
}

export default SociedadReporteContableComponent
